/**
 * Converts a grapesjs component model and its children into a plain object structure.
 * Recursively traverses all child components and extracts their attributes.
 *
 * @param component - A grapesjs component model
 * @returns An array of plain objects representing the component's children, each with attributes and nested components
 */
export function getComponents(component: any): any[] {
  function recursiveGetComponents(component: any): any[] {
    return component.get('components').models.map((comp: any) => {
      return {
        ...comp.attributes,
        components: recursiveGetComponents(comp),
      };
    });
  }
  return recursiveGetComponents(component);
}
